@if(currentURL == 'my-profile' || currentURL == 'influencer-details' || currentURL == 'list-influencers' || currentURL == 'inbox' || currentURL == 'add-experiences' || currentURL == 'my-friends' || currentURL == 'my-news-feeds' || currentURL == 'friends-refer' || currentURL == 'find-vebo-friends' || currentURL == 'add-experiences' || currentURL == 'my-settings'  || currentURL1 == 'add-experiences' || currentURL1 == 'add-experience-by-city'|| currentURL1 == 'my-settings' || currentURL == 'my-settings?claim=voucher' || currentURL1 == 'my-settings?claim=voucher' || currentURL1 =='vebo-seats' || currentURL == 'region'  || currentURL == 'gift-tracker'){
    <div class="individual-subheader" id="individual-subheader">
        <div class="container">
            <nav class="navbar navbar-expand-lg">
                <!-- <div class="wedding-couple-menu-toggle d-lg-none" id="individual-menu-toggle">
                    Menu
                    <i class="fas fa-long-arrow-down"></i>
                </div> -->
                <div class="navbar-collapse" id="individualNav" hidden>
                    <ul class="navbar-nav ">
                        <li class="nav-item">
                            @if(authUser.role_id == '4' && currentURL == 'region'){
                                <a 
                                class="nav-link" 
                                routerLink="/add-experience-by-city" [queryParams]="{'location': location_id}">
                                    RETURN TO STATE
                                </a>
                            }
                        </li>
                    </ul>
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/my-profile']">PROFILE</a>
                        </li>
                        @if(isInfluencer) {
                            <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                                <a class="nav-link" [routerLink]="['/influencer-details']">Referrals</a>
                            </li>
                        }
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL == 'add-experiences' || currentURL == 'add-experience-by-city' ||  currentURL == 'region' || currentURL1 == 'add-experience-by-city' || currentURL1 == 'add-experiences')}">
                            <a class="nav-link" [routerLink]="['/add-experiences']">Add EXPERIENCES</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/gift-tracker']">Gift tracker</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/inbox']">INBOX</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL == 'my-news-feeds' || currentURL == 'my-friends' || currentURL == 'friends-refer' || currentURL == 'find-vebo-friends')}">
                            <a class="nav-link" [routerLink]="['/my-friends']"> CONNECT
                                @if(total_notification_counter>0){
                                    <span class="blue_menu_notification_counter">
                                        {{total_notification_counter}}
                                    </span>
                                }
                                <div class="friend_counter">
                                    <img src="assets/images/icon-friend.png">
                                    @if(total_friend_counter>0){
                                        <span class="red_menu_friend_notification_counter">
                                            {{total_friend_counter}}
                                        </span>
                                    }
                                </div>
                            </a>

                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL1 == 'vebo-seats')}">
                            <a class="nav-link" [routerLink]="['/ticket-category']"> SPURTICKETING</a>
                        </li>
                        <!-- <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/notifications']">Notifications</a>
                        </li> -->
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL == 'my-settings' || currentURL == 'my-settings?claim=voucher')}">
                            <a class="nav-link" [routerLink]="['/my-settings']">Settings</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
        <!-- <div class="custom_new_teag">
        E-WALLET TOTAL:
        <br>
        <strong>$1,088.00</strong>
        </div>-->
        <!--  <div class="new_cart_pop_div" *ngIf="authCheck && is_cart_fill" >
        <div class="new_cart_popup_button_div">
            <a href="javascript:void(0);" class="cart_popup_open_button" (click)="getCartDetail()">
            <span class="cart-icon"></span>
            <span class="cart_count_popup">{{cart_details.length}}</span>
            </a>
        </div>
        </div> -->

        @if(authUser.status==2){
            <div style="background-color: #981f41;color: white;padding: 5px;text-align: center;">
                Account Inactive – You have deactivated your account and is no longer visible. To reactivate, please visit DEACTIVATE ACCOUNT.
            </div>
        }
        @if(show_card_details){
            <div class="cartpopup-wrap">
                <div class="cartpopup-overly"></div>
                <div class="cartpopup_box">
                    <div class="cartpopup_head">
                        <span class="cart_counter">
                        <span class="cart-icon"></span>
                        <span class="cart_count_popup">{{cart_details.length}}</span>
                        </span>
                        <span class="odr-title">YOUR ORDER</span>
                        <a href="javascript:void(0);" class="cart_pop_close" (click)="show_card_details = !show_card_details">
                            <i class="fa fa-times remove"></i>
                        </a>
                    </div>

                    <div class="cartpopup_content">
                        <!-- Empty Box START -->
                        @if(cart_details && cart_details.length == 0){
                            <div class="cartpopup_empty">
                                <p>Your cart is currently empty.</p>
                                <a href="javascript:void(0);" class="btn" (click)="show_card_details = !show_card_details">
                                    ← Return To Shop
                                </a>
                            </div>
                        }
                        <!-- Empty Box END -->
                        @if(cart_details && cart_details.length > 0){
                            <div class="cartpopup_content_inner">
                                <div class="cartpopup_product" *ngFor="let cart of cart_details">
                                    <div class="cartpopup_removecart">
                                        <a href="javascript:void(0);" title="Remove this item" (click)="removeItem(cart.product_id)">×</a>
                                    </div>
                                    <div class="cartpopup_proname">
                                        <a href="javascript:void(0)">{{cart.title}}</a>
                                    </div>
                                    <!-- <div class="cartpopup_vrcname">
                                            <span>Name on Voucher:</span>
                                            ashu23223 sdf estef tets sefdsf
                                        </div> -->
                                    <div class="cartpopup_proqty">
                                        Quantity: {{cart.qty}}
                                    </div>
                                    <div class="cartpopup_vrcname">
                                        <span>Option:</span> Buy For Yourself
                                    </div>
                                    <div class="row no-gutters mt-2 align-items-end">
                                        <div class="col">
                                            <div class="cartpopup_wall">
                                                <img src="{{ expUplodsUrl+cart.image }}" alt="" />
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="cartpopup_proprice">
                                                ${{cart.line_total}}
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <!-- <div class="cartpopup_product">
                                <div class="cartpopup_removecart">
                                    <a href="javascript:void(0);" title="Remove this item">×</a>
                                </div>
                                <div class="cartpopup_proname">
                                    <a href="javascript:void(0)">Group Fly Fishing</a>
                                </div>
                                <div class="cartpopup_vrcname">
                                    <span>Name on Voucher:</span>
                                    ashu23223 sdf estef tets sefdsf
                                </div>
                                <div class="cartpopup_proqty">
                                    Quantity: 1
                                </div>
                                <div class="cartpopup_vrcname">
                                    <span>Option:</span>
                                    Buy For Yourself
                                </div>
                                <div class="row no-gutters mt-2 align-items-end">
                                    <div class="col">
                                    <div class="cartpopup_wall">
                                        <img src="assets/images/home_owl_1.jpg" alt="" />
                                    </div>
                                    </div>
                                    <div class="col">
                                    <div class="cartpopup_proprice">
                                        $525
                                    </div>
                                    </div>
                                </div>
                                </div> -->
                            </div>
                        }
                        @if(cart_details && cart_details.length > 0){
                            <div class="cartpopup_content_footer">
                                <div class="cartpopup_total">
                                    <div class="form-row">
                                        <div class="col">
                                            <strong>Sales Tax</strong>
                                        </div>
                                        <div class="col">
                                            <div class="cartpopup-amount">${{total_sales_tax}}</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col">
                                            <strong>Total: </strong>
                                        </div>
                                        <div class="col">
                                            <div class="cartpopup-amount">${{total_cart_amount}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cartpopup_continueshop_btn">
                                    <a href="javascript:void(0)" (click)="show_card_details = !show_card_details">Continue Shopping</a>
                                </div>
                                <div class="cartpopup_checkout_btn">
                                    <a href="javascript:void(0)" (click)="checkout()">CHECKOUT</a>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
}
@if(currentURL=='ticket-category' || currentURL=='ticket-evolution-category' || currentURL=='our-tickets'){
    <div>
        <app-veboticketing-subheader></app-veboticketing-subheader>
    </div>
}
